import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import OrderDetails from './components/OrderDetails';
import Products from './components/Products';
import Coupons from './components/Coupons';
import ShipstationOrder from './components/ShipstationOrder';
import ShipstationOrderDetail from './components/ShipstationOrderDetail';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
                        <Routes>
                  <Route path="/" element={<Login />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/coupons" element={<Coupons />} />
                  <Route path="/shipstation-orders" element={<ShipstationOrder />} />
                  <Route path="/shipstation-order/:orderId" element={<ShipstationOrderDetail />} />
                  <Route path="/order/:orderId" element={<OrderDetails />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
      </div>
    </Router>
  );
}

export default App;
